import {Component, OnInit, Input} from '@angular/core';
import {ApplicationItemViewModel} from './../application-item.view-model';

@Component({
  selector: 'ndms-application-card-group',
  templateUrl: './application-card-group.component.html',
  styleUrls: ['./application-card-group.component.scss']
})
export class ApplicationCardGroupComponent implements OnInit {
  appList: any[];

  @Input() set applicationList(value: ApplicationItemViewModel[]) {
    this.appList = value || [];
  }

  @Input() groupHeader;

  constructor() {
  }

  ngOnInit() {
  }

}
